import { reportError } from "./errorUtils";
import { isString } from "lodash";

export type FileData = {
  name: string;
  mimeType: string;
  base64: string;
};

function base64Of(dataUrl: string): string {
  return dataUrl.slice(dataUrl.indexOf(",") + 1);
}

function mimeTypeOf(dataUrl: string): string {
  return dataUrl.slice("data:".length, dataUrl.indexOf(";"));
}

export async function toAttachment(file: File): Promise<FileData> {
  const dataUrl = await readAsBase64DataUrl(file);
  if (dataUrl !== null && isString(dataUrl)) {
    return {
      name: file.name,
      mimeType: file.type,
      base64: base64Of(dataUrl)
    };
  } else {
    reportError(`Failed to read file base64 data URL with type ${typeof dataUrl}`);
    throw new Error("Failed to load file");
  }
}

export function fromDataUrl(dataUrl: string, fileName: string): FileData {
  return {
    name: fileName,
    mimeType: mimeTypeOf(dataUrl),
    base64: base64Of(dataUrl)
  };
}

export function toDataUrl(attachment: FileData) {
  return `data:${attachment.mimeType};base64,${attachment.base64}`;
}

function readAsBase64DataUrl(file: File): Promise<FileReader["result"]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
